var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagging(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.704,
    height: 26.529,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5814"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7741",
    d: "M32.111 12.301L20.56.708l-1.168 1.168 11.551 11.593a2.085 2.085 0 010 2.961l-7.34 7.34a2.085 2.085 0 01-2.961 0l-1.251-1.251 4.921-4.921a3.753 3.753 0 000-5.3L14.095 2.081a3.337 3.337 0 00-2.419-.959l-7.756.125A3.336 3.336 0 00.667 4.5L.5 12.256a3.335 3.335 0 00.959 2.419l10.217 10.258a3.753 3.753 0 005.3 0l1.251-1.251 1.251 1.251a3.753 3.753 0 005.3 0l7.34-7.34a3.753 3.753 0 000-5.3zM15.806 23.769a2.085 2.085 0 01-2.961 0L2.633 13.548a1.667 1.667 0 01-.5-1.209L2.3 4.583a1.668 1.668 0 011.626-1.626l7.756-.167h.042a1.667 1.667 0 011.168.5L23.15 13.465a2.084 2.084 0 010 2.961l-4.921 4.921z",
    fill: "#5222f1",
    stroke: "#5200f1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagging);
export default __webpack_public_path__ + "static/media/tagging.67861f434620c31b51f412a3ee4c8fcc.svg";
export { ForwardRef as ReactComponent };